export default __webpack_public_path__ + "d6c7aa6bd1a52abecaf0f8f31b1f7018.gif";